import React,{useEffect, useState} from 'react';
import "./Wifi.css";
import Header from "../../components/Header"
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import useAuth from '../../../customHooks/useAuth';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../common/baseUrl';
import PageLoader from '../../components/PageLoader/PageLoader';
import axiosInstance from '../../../axiosInstance/axiosInstance';
import { getCurrentUser } from '../../../common/currentUser';
import Dropdown from "../../components/Dropdown/Dropdown";

export default function Wifi() {

  const location = useLocation();
  const navigate = useNavigate();

  const bookedRooms = location.state?.bookedRooms || [];
  const userId = localStorage.getItem("user_id");

  const hotelId = location.state?.hotelId || "";
  const bookingId = location.state?.bookingId || "";
  const hotelAddress = location.state?.hotelAddress || "";
  const hotelName = location.state?.hotelName || '';
  const checkInDate = location.state?.checkInDate || "";
  const checkOutDate = location.state?.checkOutDate || "";
  const status = location.state?.status || "";
  const activeTab = location.state?.activeTab || "";
  const booking_code = location.state?.booking_code || "";

  // Refresh Handle
  useAuth();

  // Devices
  const [qty,setQty] = useState(1);

  // Error Handling
  const [errors, setErrors] = useState({});

  // Form Data
  const [formData,setFormData] = useState({
    comment : "",
    room : "",
    devices : qty
  });

  // Loader
  const [isLoading,setIsLoading] = useState(false);

  // Check Id's
  useEffect(()=>{
    const checkId = ()=>{
      if(hotelId==="" || bookingId===""){
        navigate("/bookings");
      }
    }
    checkId();
  },[bookingId,hotelId,navigate])


  // Increase Qty
  const increaseQty = () => {
    const newQty = qty + 1;
    setQty(newQty);
    setFormData((prevState) => ({
        ...prevState,
        devices: newQty,
    }));
  }

  // Decrease Qty
  const decreaseQty = () => {
    if (qty > 1) {
        const newQty = qty - 1;
        setQty(newQty);
        setFormData((prevState) => ({
          ...prevState,
          devices: newQty,
        }));
    }
  }


  // OnChange
  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));     
    validateField(name,value)
  };


  // Validate Field
  const validateField = (field,value) => {
    const newErrors = { ...errors };
    switch(field){
      // case "comment":
      //   if(!value.trim()){
      //     newErrors.comment = "Comment is required";
      //   }else{
      //     newErrors.comment = "";
      //   }
      // break;

      case "room" :
        if(!value.trim()){
          newErrors.room = "Room Selection is required";
        }
        else{
          newErrors.room = "";
        }
        break;

      default :
        break;
    }
    setErrors(newErrors);

  }

  // Validate Form
  const validateForm = () => {

    const validationErrors = {};
    // if(!formData.comment){
    //   validationErrors.comment = "Comment is required";
    // }
    if(!formData.room){
      validationErrors.room = "Room Selection is required";
    }
    setErrors(validationErrors);
    
    return Object.keys(validationErrors).length === 0;
  }


  // Handle Submit
  const handleSubmit = async() => {
    try{
      if(!validateForm()){
        // console.log("Please Validate Form");
        return;
      }
      setIsLoading(true);

      const currentUser = await getCurrentUser();
 
      function findMatchedRooms(bookedRooms, usersData) {
          const contact = usersData.contact;
          const matchedRooms = bookedRooms.filter((room)=>{
              // Check if guests are null or an empty array, and skip the room if true
              if (!room.guests || room.guests.length === 0) {
                  return false; // Skip this room
              }
              const matchedGuest = room.guests.find((guest)=>guest.contact===contact);
              if(matchedGuest) {
                  return true; //
              }
              else{
                  return false;
              }
          });
          return matchedRooms;
      }        

      const usersData = currentUser;  
      const matchedRooms = findMatchedRooms(bookedRooms, usersData);

      if(matchedRooms.length<=0){
        // console.log("Booking is not Present ");
        return;
      }
      // console.log("MAtched Rooms : " + matchedRooms[0].id);




      // console.log("Form Data : ",formData)
      const roomData = bookedRooms.find(item=>item.id===formData.room);
      // console.log("Room Number : ",roomData.room_number);
      const passData = {
        number_of_devices : formData.devices,
        service_room : roomData.room_number,
        additional_comments : formData.comment
      };

      try{
        const response = await axiosInstance.post(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${matchedRooms[0].id}/guest-requests/post-checkin/wifi-request/`,passData);
  
        // console.log("Response : ",response.data);

        toast.success("Wifi Request Created Successfully");
        navigate("/bookings",{state : {activeRequests : "requests"}})

      }catch(error){
        toast.error(error?.response?.data?.message || "Some Error Occured");
        console.log(error);
      }

    }catch(error){
      console.log(error);
    }
    finally{
      setIsLoading(false);
    }
 
  }




  return (
    <>
      {
        isLoading && <PageLoader/>
      }
      <div className="wifi">
        <Header title="WiFi Details" 
          hotelName = {hotelName}
          hotelAddress = {hotelAddress}
          checkInDate = {checkInDate}
          checkOutDate = {checkOutDate}
          status = {status}
          activeTab = {activeTab}
          hotelId = {hotelId}
          bookingId = {bookingId}
          movetoHotel = "movetoHotel"
          booking_code = {booking_code}
        />
        <div className="wifi-data">
          
          {/* Devices */}
          <div className="wifi-fields">
            <div className="wifi-name">
              <h4>Number of devices</h4>
            </div>
            <div className="wifi-inpGuests">
              <div className='qtyButton' onClick={decreaseQty} >-</div>
              <div className='qty'>{qty}</div>
              <div className='qtyButton' onClick={increaseQty}>+</div>
            </div>
          </div>

          {/* Comments */}
          <div className="wifi-fields">
            <div className="wifi-name">
              <h4>Comments</h4>
            </div>
            <div className="wifi-comment">
              <textarea name="comment" value={formData.comment} rows='4' cols="10" onChange={handleChange} ></textarea>
            </div>
            {/* {errors.comment && <span className="error-message">{errors.comment}</span>} */}
          </div>

          {/* Service Room */}
          <div className="wifi-fields">
            <div className="wifi-name">
              <h4>Service Room</h4>
            </div>
            <div className='wifi-inps'>
              
              {/* Select Room */}
              <div className='wifiSelect'>
              <Dropdown
                name="room"
                value={formData.room}
                onChange={handleChange}
                placeholder="Select a room"
                options={bookedRooms
                                    .filter(room => room.room_number)
                                    .map(room => ({ value: room.id, label: String(room.room_number) }))}
              />

              </div>
              
              {/* Button */}
              <div className='wifi-btn'>
                <button onClick={handleSubmit} disabled={formData.room===""} >Send Requet</button>
              </div>

            </div>
            {errors.room && <span className="error-message">{errors.room}</span>}
          
          </div>


        </div>
      </div>
    </>
  )
}
